import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import SavingsClub from "../components/SavingsClub/SavingsClub"

const Savings = () => {
  return (
    <Layout>
      <SEO title="Savings Club"/>
      <SavingsClub/>
    </Layout>
  )
}

export default Savings
